import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Content from '../../../layout/Content'
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes'
import CabinCrewForSchedulingSearchForm from './CabinCrewForSchedulingSearchForm'
import Table from '../../../common/Table'
import { CABIN_CREW_FOR_SCHEDULING_COLUMNS } from '../../../../config/columns'
import { tzNormalizeDate } from '../../../../utils/date'
import { INT_DATE_FORMAT } from '../../../../config/locale'
import { clearCabinCrewForScheduling, getCabinCrewForScheduling } from '../../../../actions/traffic/CabinCrewForScheduling'

const CabinCrewForScheduling = ({ breadcrumbs, itineraries, loading, dispatchGetCabinCrewForScheduling, dispatchClearCabinCrewForScheduling }) => {

  useEffect(() => () => {
    dispatchClearCabinCrewForScheduling()
  }, []);

  const handleSearchSubmit = (formValues) => {
    const newFormValues = {
      fromDateString: tzNormalizeDate({ date: formValues.fromDateString, format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ date: formValues.toDateString, format: INT_DATE_FORMAT }),
      itineraryDirection: formValues.direction ? formValues.direction.value : null,
      homeBaseLocationId: formValues.homeBaseLocation ? formValues.homeBaseLocation.value : null,
      showNorteChico: formValues.showNorteChico,
    }

    const { serviceTypes } = formValues;

    if (serviceTypes) {
      newFormValues.serviceTypes = serviceTypes.map(st => st.value);
    }

    dispatchGetCabinCrewForScheduling(newFormValues)
  }

  const defaultFilterMethod = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const value = row[id];

    if (value == null) return false;

    return String(value)
      .toLowerCase()
      .includes(String(filter.value).toLowerCase());
  };

  const content = (
    <>
      <CabinCrewForSchedulingSearchForm onSubmit={handleSearchSubmit} loading={loading} />
      <Table
        data={itineraries || []}
        columns={CABIN_CREW_FOR_SCHEDULING_COLUMNS}
        loading={loading}
        manual={false}
        filterable
        defaultFilterMethod={defaultFilterMethod}
      />
    </>
  )

  return (
    <Content
      title="Programación de Servicio a Bordo"
      content={content}
      breadcrumbs={breadcrumbs}
    />
  )
}

CabinCrewForScheduling.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  itineraries: PropTypes.arrayOf(PropTypes.shape({
    departureDate: PropTypes.number,
    sourceLocationName: PropTypes.string,
    destinationLocationName: PropTypes.string,
    serviceTypeName: PropTypes.string,
    companyBusId: PropTypes.string,
    registeredBusHomeBaseName: PropTypes.string,
    cabinCrewName: PropTypes.string,
    idDocumentNumberCabinCrew: PropTypes.string,
    itineraryDirection: PropTypes.string,
    routeName: PropTypes.string,
    itineraryId: PropTypes.number,
  })).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetCabinCrewForScheduling: PropTypes.func.isRequired,
  dispatchClearCabinCrewForScheduling: PropTypes.func.isRequired,
}

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Programación de Servicio a Bordo',
      href: '',
    },
  ],
  itineraries: TrafficUnit.CabinCrewForScheduling.getIn(['all', 'content', 'content']),
  loading: TrafficUnit.CabinCrewForScheduling.getIn(['all', 'loading']),
})

const mapDispatchToProps = {
  dispatchGetCabinCrewForScheduling: getCabinCrewForScheduling,
  dispatchClearCabinCrewForScheduling: clearCabinCrewForScheduling,
}

export default connect(mapStateToProps, mapDispatchToProps)(CabinCrewForScheduling)